<template>
	<div v-if="!setupSectionIsComplete(settingKey) && !$store.fetchingSetupStatus" class="alert alert-info">
		<h2>{{title}}</h2>

		<slot></slot>

		<button class="btn btn-success" type="button" v-on:click="markSectionAsSetupComplete(settingKey,nextLink)">
			<i class="fa fa-check-circle"></i>
			I am finished setting up {{name}}
		</button>

		<router-link v-if="nextLink" class="btn btn-light" :to="nextLink">
			<i class="fa fa-check"></i>
			Skip to Next Steps
		</router-link>
	</div>
	<div v-else></div>
</template>
<script type="text/javascript">
import OnboardingMixins from "@/mixins/OnboardingMixins.js"

export default {
	name: "OnboardingCard",
	props: [
		"title",
		"name",
		"settingKey",
		"nextLink"
	],
	mixins: [OnboardingMixins],
	methods: {
		markSectionAsSetupComplete(section,nextLink) {
			let vm = this

			let setupProgressObj = this.convertSetupProgressJsonToObj(this.$store.company.CompanySetting.setup_progress_json)

			setupProgressObj[section] = true

			let payload = {
				setup_progress_json: JSON.stringify(setupProgressObj)
			}

			this.postData("CompanySetting/save",payload).then(response => {
				if (response.success) {
					vm.$store.company.CompanySetting.setup_progress_json = JSON.stringify(setupProgressObj)

					if (nextLink)
						vm.$router.push(nextLink)

					else
						vm.$emit("sectionComplete")
				}
			})
		}
	}
}
</script>